var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paperclip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0001 4.49939L5.68907 10.9395C5.40769 11.2209 5.24961 11.6026 5.24961 12.0005C5.24961 12.3984 5.40769 12.7801 5.68907 13.0615C5.97046 13.3429 6.3521 13.5009 6.75004 13.5009C7.14798 13.5009 7.52962 13.3429 7.811 13.0615L14.122 6.62135C14.6847 6.05867 15.0008 5.29552 15.0008 4.49977C15.0008 3.70402 14.6847 2.94087 14.122 2.37819C13.5594 1.81551 12.7962 1.4994 12.0005 1.4994C11.2047 1.4994 10.4416 1.81551 9.87892 2.37819L3.59415 8.79206C3.17066 9.20871 2.83386 9.70509 2.60317 10.2526C2.37247 10.8 2.25246 11.3878 2.25004 11.9818C2.24762 12.5759 2.36285 13.1646 2.58907 13.7139C2.8153 14.2633 3.14805 14.7624 3.56813 15.1825C3.98821 15.6025 4.4873 15.9353 5.03662 16.1615C5.58595 16.3878 6.17462 16.503 6.7687 16.5006C7.36278 16.4981 7.95049 16.3781 8.49796 16.1474C9.04542 15.9167 9.54178 15.5799 9.95843 15.1564L16.2432 8.74256",
    stroke: "#6B7280",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarType);
export default __webpack_public_path__ + "static/media/toolbar-type.45707ffb553782bcaf11c62326187fab.svg";
export { ForwardRef as ReactComponent };